// AppType: shell 切替 (legacy 軸).
// LEGACY = 旧 yakureki UI (= ramp 終着点で物理 rm)
// LATEST = 現在の正典 shell (= ramp 完了後の唯一 app)
//
// 命名は永続的な時間軸 (= legacy / latest) で統一.
// 「classic」「notion」 等の category 名は時間で陳腐化するため避ける
// (= memory feedback_legacy_axis_naming).

export const APP_TYPES = {
  LEGACY: 'legacy',
  LATEST: 'latest',
} as const

export type AppType = (typeof APP_TYPES)[keyof typeof APP_TYPES]

export const isLegacyApp = (appType: AppType): boolean =>
  appType === APP_TYPES.LEGACY

export const isLatestApp = (appType: AppType): boolean =>
  appType === APP_TYPES.LATEST
